/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export type DateOutlinedIconProps = {
  color?: string;
  size?: IconSize | number;
}
/*
 * Defines the Design Language System (DLS) Date Outlined Icon component.
 */
export const DateOutlinedIcon = ({color = dlsColor('grey3'), size = 24}: DateOutlinedIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.4999 5.77441H4.5C4.22386 5.77441 4 5.99827 4 6.27441V19.6744C4 19.9506 4.22386 20.1744 4.5 20.1744H19.4999C19.776 20.1744 19.9999 19.9506 19.9999 19.6744V6.27441C19.9999 5.99827 19.776 5.77441 19.4999 5.77441Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M4.10352 10.9736H20.0001" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M7.73047 4V7.51255" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M16.0117 4V7.51255" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  );
};

export default DateOutlinedIcon;
